/*
 *  			'License for ONE AXA SOFTWARE - Inner Source'
 * 					L O A S - I S
 * 
 * The following License aims to be applied between the AXA Companies, according to the following definition:
 * "AXA Companies" means AXA, Société Anonyme with a “AXA Companies ” Board of Directors having its principal offices at 25, avenue Matignon, 75008 Paris, registered on the Commercial Registry of Paris under the number 572 093 920; and (i) any other company controlled by, or controlling AXA, with a company being considered as controlling another: (a) when it holds directly or indirectly a portion of the capital according to it the majority of the voting rights in general meetings of shareholders of this company; (b) when it holds solely the majority of the voting rights in this company by virtue of an agreement concluded with other partners or shareholders and which is not contrary to the interest of the company; (c) when it determines de facto, by voting rights which it holds, the decisions in the general meetings of shareholders of this company; (d) in any event, when it holds, directly or indirectly, a portion of voting rights greater than 40% and when no other partner or shareholder holds directly or indirectly a portion which is greater than its own; (ii) any economic interest group in which AXA and/or one or more other Companies of the AXA Group participates for at least 50% in operating costs; (iii) in the cases where the law applicable to a company limits voting rights or control (such as defined here in above), this company will be deemed to be a company of the AXA Group, if the voting rights in 2 Binding Corporate Rules – AXA Group – version 2013 general shareholders’ meetings or the control held by a Company of the AXA Group reaches the maximum amount fixed by said applicable law; and (iv) all AXA Companies constitute the “AXA Group” (hereafter "One AXA").  (Binding Corporate Rules - AXA Group - version 2019).
 * 
 * Software credits: 
 * 	Creator: AXA GO GETD
 * 	Main contributors: AXA GO GETD
 * 
 * Permission is hereby granted, free of charge, to any person or entity within One AXA obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software within One AXA, including the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
 * 
 * The above credit notice and this permission notice shall be included in all copies or substantial portions of the Software.
 * Any improvement or modification of the Software shall be made available to the whole One AXA, under the terms of this License.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */

import React from 'react';
import { InfoTooltip } from '@components/commons/tooltip/infoTooltip';
import { idField } from '@constants';
import SvgIconDelete from '@svg/IconDelete';
import SvgIconEdit from '@svg/IconEdit';
import SvgIconEye from '@svg/IconEye';
import { Badge, Button, Popconfirm, Space, Tooltip } from 'antd';
import { Link } from 'react-router-dom';
import Highlighter from 'react-highlight-words';
import { FilterFilled } from '@ant-design/icons';
import { colors } from '@styles/theme';
import { FilterComponent, getFilterValues } from '../../common/filters';

const { MESSAGES } = require('@translations/labels');

const labels = { ...MESSAGES.manageBot };

const getDistinctLanguages = domains => getFilterValues(domains, 'language');
const getDistinctDomains = domains => getFilterValues(domains, 'name');

export const columns = ({
  intents,
  handleEdit,
  handleDelete,
  versionId,
  domainFilter,
  searchText,
  deepSearch,
  handleReset,
  existingDomains,
}) => [
  {
    title: () => <span className="bold">{labels.tableIntentName}</span>,
    key: 'action',
    fixed: true,
    width: 400,
    render: intent => {
      return (
        <Button size="small" type="ghost" onClick={handleEdit(intent)} style={{ border: 'none' }}>
          <div style={{ display: 'flex' }}>
            {intent.isEnabled ? (
              <Tooltip placement="right" title={labels.tableIntentActive}>
                <Badge status="success" />
              </Tooltip>
            ) : (
              <Tooltip placement="right" title={labels.tableIntentInactive}>
                <Badge status="error" />
              </Tooltip>
            )}
            <Link
              to={`/manage-the-bot/intents/${intent[idField]}/${!versionId ? 'edit' : 'view'}`}
              className="link-secondary block"
            >
              {searchText && deepSearch !== 'EXAMPLES' ? (
                <Highlighter
                  highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
                  searchWords={[searchText]}
                  autoEscape
                  textToHighlight={intent.name ?? ''}
                />
              ) : (
                intent.name
              )}
            </Link>
          </div>
        </Button>
      );
    },
  },
  {
    title: <span className="bold ">{labels.tableDomainName}</span>,
    className: 'filter-column',
    dataIndex: 'domainName',
    key: 'domainName',
    fixed: true,
    width: 200,
    defaultFilteredValue: domainFilter ? [domainFilter.name] : [],
    filterMultiple: false,
    filterIcon: filtered => <FilterFilled style={{ color: filtered ? colors.primary : undefined }} />,
    onFilter: (value, record) => record.domainName === value,
    ...FilterComponent(existingDomains, handleReset, getDistinctDomains),
  },
  {
    title: <span className="bold ">{labels.tableLanguage}</span>,
    dataIndex: 'domainLanguage',
    key: 'domainLanguage',
    fixed: true,
    width: 150,
    filterMultiple: false,
    filterIcon: filtered => <FilterFilled style={{ color: filtered ? colors.primary : undefined }} />,
    onFilter: (value, record) => record.domainLanguage === value,
    ...FilterComponent(existingDomains, handleReset, getDistinctLanguages),
  },
  {
    title: <span className="bold ">{labels.tablePriority}</span>,
    dataIndex: 'priority',
    key: 'priority',
    fixed: true,
    width: 150,
  },
  /* // TODO: WIP , isFeedbackNeeded */
  // {
  //   title: <span className="bold ">{labels.tableAskFeedback}</span>,
  //   dataIndex: 'isFeedbackNeeded',
  //   key: 'isFeedbackNeeded',
  //   align: 'left',
  //   fixed: true,
  //   width: 150,
  // },
  {
    title: (
      <div>
        <span className="bold ">{labels.tableExamples}</span>
        <InfoTooltip label="User sentences and questions amount" />
      </div>
    ),
    key: 'utterancesAmount',
    dataIndex: 'utterancesAmount',
    align: 'left',
    fixed: true,
    width: 150,
    render: text => {
      if (Number(text) >= 10) {
        return <b className="accent-positive">{text}</b>;
      }
      if (Number(text) >= 5) {
        return <b className="accent-informative">{text}</b>;
      }
      return <b className="accent-negative">{text}</b>;
    },
  },
  {
    title: '',
    key: 'action',
    fixed: true,
    width: 100,
    render: record => {
      return intents.length > 0 ? (
        <>
          <Space size="middle">
            <Button size="small" type="ghost" onClick={handleEdit(record)} style={{ border: 'none' }}>
              {!versionId ? (
                <Link to={`/manage-the-bot/intents/${record[idField]}/edit`}>
                  <SvgIconEdit width="14px" height="14px" />
                </Link>
              ) : (
                <Link to={`/manage-the-bot/intents/${record[idField]}/view`}>
                  <SvgIconEye width="14px" height="14px" />
                </Link>
              )}
            </Button>
            {!versionId && (
              <Popconfirm title="Sure to delete?" onConfirm={handleDelete(record)}>
                <Button
                  size="small"
                  type="ghost"
                  icon={<SvgIconDelete width="14px" height="14px" />}
                  style={{ border: 'none' }}
                />
              </Popconfirm>
            )}
          </Space>
        </>
      ) : null;
    },
  },
];
